import { SAMPLE_RATE_HOURLY_TITLE, SAMPLE_RATE_DAILY_TITLE, SAMPLE_RATE_WEEKLY_TITLE, SAMPLE_RATE_MONTHLY_TITLE, SAMPLE_RATE_YEARLY_TITLE } from 'js/constants/text';
export var HOURLY_SAMPLE_RATE_ABBREVIATION = 'H';
export var DAILY_SAMPLE_RATE_ABBREVIATION = 'D';
export var WEEKLY_SAMPLE_RATE_ABBREVIATION = 'W';
export var MONTHLY_SAMPLE_RATE_ABBREVIATION = 'M';
export var YEARLY_SAMPLE_RATE_ABBREVIATION = 'Y';
export var HOURLY_SAMPLE_RATE = {
  abbreviation: HOURLY_SAMPLE_RATE_ABBREVIATION,
  title: SAMPLE_RATE_HOURLY_TITLE
};
export var DAILY_SAMPLE_RATE = {
  abbreviation: DAILY_SAMPLE_RATE_ABBREVIATION,
  title: SAMPLE_RATE_DAILY_TITLE
};
export var WEEKLY_SAMPLE_RATE = {
  abbreviation: WEEKLY_SAMPLE_RATE_ABBREVIATION,
  title: SAMPLE_RATE_WEEKLY_TITLE
};
export var MONTHLY_SAMPLE_RATE = {
  abbreviation: MONTHLY_SAMPLE_RATE_ABBREVIATION,
  title: SAMPLE_RATE_MONTHLY_TITLE
};
export var YEARLY_SAMPLE_RATE = {
  abbreviation: YEARLY_SAMPLE_RATE_ABBREVIATION,
  title: SAMPLE_RATE_YEARLY_TITLE
};